import ApiClient from './ApiClient';

export const buildParams = (page, sortAttr = 'id', search = '', limit = 15) => {
  let params = `page=${page}&limit=${limit}&sort=${sortAttr}`;

  if (search) {
    params = `${params}&q=${search}`;
  }

  return params;
};

class Call extends ApiClient {
  constructor() {
    super('calls', { accountScoped: true });
  }

  getSettings(inboxId) {
    let requestURL = `${this.url}/settings/${inboxId}`;

    return axios.get(requestURL);
  }

  updateSettings(inboxId, settings) {
    let requestURL = `${this.url}/settings/${inboxId}`;

    return axios.post(requestURL, { settings });
  }
}

export default new Call();
